import React, { useContext, useState } from 'react'
import { MainLogo } from '../../../helper/imagepath'
import { resetPasswordSchema } from '../../../util/validationSchema'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { resetPassword } from '../../../redux/slices/authSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const { token } = useParams()

  // Get search params
  const [searchParams] = useSearchParams()

  // Access token from query params
  const token = searchParams.get('token')

  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  const {
    handleSubmit,
    formState: { errors },
    control
  } = useForm({ resolver: yupResolver(resetPasswordSchema) })

  const onSubmit = (data) => {
    const payload = {
      token: token,
      password: data?.password
    }
    if (payload) {
      changeLoader(true)
      dispatch(resetPassword(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
          navigate('/login')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="auth-wrapper-main">
      <div className="auth-container">
        <div className="text-center">
          <img className="img-fluid auth_logo" src={MainLogo} alt="Logo" />
        </div>

        <div className="authbox">
          <div className="auth-left">
            <div className="auth-page-title">Reset Your Password</div>
            <p className="auth-page-sub-title">The password must be different than before</p>

            <div className="auth-form-content">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group input_text">
                  <label className="form-control-label">New Password</label>
                  <span className="text-danger"> *</span>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <div className="pass-group">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter Your New Password"
                          onCopy={(e) => e.preventDefault()} // Disable copy
                          onCut={(e) => e.preventDefault()} // Disable cut
                        />
                        <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                      </div>
                    )}
                    defaultValue=""
                  />

                  <small>{errors?.password?.message}</small>
                </div>

                <div className="form-group input_text">
                  <label className="form-control-label">Confirm Password</label>
                  <span className="text-danger"> *</span>
                  <Controller
                    name="confirmPassword"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <div className="pass-group">
                        <input
                          type={showConfirmPassword ? 'text' : 'password'}
                          className={`form-control  ${errors?.confirmPassword ? 'error-input' : ''}`}
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                          placeholder="Enter Your Confirm Password"
                          onCopy={(e) => e.preventDefault()} // Disable copy
                          onPaste={(e) => e.preventDefault()} // Disable paste
                          onCut={(e) => e.preventDefault()} // Disable cut
                        />
                        <span
                          onClick={onConfirmPasswordEyeClick}
                          className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                        />
                      </div>
                    )}
                    defaultValue=""
                  />
                  <small>{errors?.confirmPassword?.message}</small>
                </div>

                <div className="auth-btn-div">
                  <button className="btn" type="submit">
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="auth-right auth-reset-pwd-bg-img"></div>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
